module.exports = __webpack_public_path__ + "static/media/list_zestaw.aea992b4.png";